import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import CustomDatatableGrid from "../../components/CustomDatatableGrid";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";
import { customTableStyles } from "../../assets/CustomTableStyles";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import logo from "../../assets/img/logo-full.png";
import DropdownWithCustomValuesModal from "../../components/DropdownWithCustomValuesModal";

function BankSetup() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");

  const [booksList, setBooksList] = useState([]);
  const [filteredBooksList, setFilteredBooksList] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [triggerRerender, setTriggerRerender] = useState(false);
  const [centerId, setCenterId] = useState(savedCenterId || null);
  const [libraryId, setLibraryId] = useState("");
  const [centersData, setCentersData] = useState([]);
  const [librariesData, setLibrariesData] = useState([]);
  const [userForList, setUserForList] = useState([]);
  const [customDropdownName, setCustomDropdownName] = useState("");
  const [activityCategoryData, setActivityCategoryData] = useState([]);
  const [activityVenueData, setActivityVenueData] = useState([]);

  const [
    isCustomDropdownValuesModalVisible,
    setIsCustomDropdownValuesModalVisible,
  ] = useState(false);
  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    reset,
    trigger,
  } = useForm({
    defaultValues: {
      bankCode: "",
      bankName: "",
      ibanNo: "",
      bbanNo: "",
      usedFor: "",
      inActive: false,
      excelFile: null,
      createdBy: localStorage.getItem("userId"),
    },
  });

  const usedForValue = watch("usedFor"); // Watch the usedFor field
  const fetchCommonSettings = async (moduleName, setData) => {
    try {
      const response = await get(
        `CommonSettings/GetCommonSettingDetailByModuleName?moduleName=${moduleName}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setData(response?.commonSettingDetail);
    } catch (error) {
      console.error(`Error fetching ${moduleName}:`, error);
    }
  };
  useEffect(() => {
    const fetchCenters = async () => {
      try {
        const response = await get(
          `Dropdown/GetAllCentersByOrganizationId?organizationId=${organizationId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setCentersData(response);

        if (savedCenterId) {
          const selectedCenter = response.find(
            (center) => center.id === parseInt(savedCenterId, 10)
          );
          if (selectedCenter) {
            setValue("centerId", {
              value: selectedCenter.id,
              label: selectedCenter.name,
            });
          }
        }
      } catch (error) {
        console.error("Error fetching centers:", error);
      }
    };

    fetchCenters();
  }, [organizationId, setValue, savedCenterId]);

  const getLibrariesListByCenterId = async (centerId) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await get(
        `LMS/GetLibraryByCenterIdAsync?centerId=${centerId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setLibrariesData(response?.libraryService || []);
    } catch (error) {
      console.error("Error fetching libraries:", error);
    }
  };

  useEffect(() => {
    if (centerId) {
      getLibrariesListByCenterId(centerId);
    }
  }, [centerId]);

  useEffect(() => {
    const getUserForList = async () => {
      if (!token) {
        console.error("Unauthorized.");
        return;
      }

      try {
        const response = await get(
          `CommonSettings/GetCommonSettingDetailByModuleName?moduleName=BankUsedForDropdown`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setUserForList(response?.commonSettingDetail || []);
      } catch (error) {
        console.error("Error fetching user for list:", error);
      }
    };

    getUserForList();
    getBooksListByLibraryId();
  }, [organizationId]);

  const getBooksListByLibraryId = async () => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }
    try {
      const response = await get(`CommonSettings/GetBankSetup`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setFilteredBooksList(response || []);
    } catch (error) {
      console.error("Error fetching books:", error);
    }
  };

  const handleEdit = async (bookId) => {
    try {
      const response = await get(`LMS/GetBooksByIdAsync?bookId=${bookId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const { bookService: singleBookData } = response;
      reset({
        ...singleBookData,
        id: singleBookData.id,
        updatedBy: localStorage.getItem("userId"),
      });
    } catch (error) {
      console.error("Error editing book:", error);
    }
  };

  const columns = [
    {
      accessorKey: "mrt-row-numbers",
      header: "Sr No.",
      enableColumnOrdering: false,
      enableEditing: false,
      enableSorting: false,
      size: 80,
      Cell: ({ row }) => row.index + 1,
    },
    // {
    //   header: "bankCode",
    //   accessorKey: "bankCode",
    //   sortable: true,
    //   width: "50px",
    //   omit: true,
    // },
    {
      header: "Bank Name",
      accessorKey: "name",
      // size: 120,
    },
    {
      header: "IBAN",
      accessorKey: "iban",
      // size: 120,
    },
    {
      header: "Virtual IBAN",
      accessorKey: "virtualIBAN",
      // size: 150,
    },
    {
      header: "Roll No.",
      accessorKey: "rollNo",
      // size: 150,
    },
    // {
    //   name: "Action",
    //   width: "70px",
    //   selector: (row) => (
    //     <div>
    //       <button
    //         type="button"
    //         className="btn p-0"
    //         onClick={() => handleEdit(row.id)}
    //       >
    //         <i className="fas fa-pencil"></i>
    //       </button>
    //     </div>
    //   ),
    // },
  ];

  const exportToExcel = () => {
    const filteredData = filteredBooksList.map((row, index) => ({
      "Sr No": index + 1,
      Title: row.title,
      "No. of Copies": row.copiesAvailable,
    }));

    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Books");
    XLSX.writeFile(workbook, "Books.xlsx");
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const logoWidth = 30;
    const logoHeight = 8;
    const logoX = (pageWidth - logoWidth) / 2;
    const logoY = 10;
    // doc.addImage(logo, "PNG", logoX, logoY, logoWidth, logoHeight);

    const title = "IBAN List";
    const titleFontSize = 12;
    doc.setFontSize(titleFontSize);
    doc.setFont("helvetica", "bold");
    const textWidth = doc.getTextWidth(title);
    const titleX = (pageWidth - textWidth) / 2;
    const titleY = logoY + logoHeight + 10;
    doc.text(title, titleX, titleY);

    const includedColumns = columns.filter((column) => !column.omit);
    const headers = includedColumns
      .filter((col) => col.name !== "ID" && col.name !== "Action")
      .map((col) => col.name);

    const bodyData = filteredBooksList.map((row, index) => [
      index + 1,
      ...includedColumns
        .filter(
          (column) =>
            column.name !== "ID" &&
            column.name !== "Action" &&
            column.name !== "Sr No."
        )
        .map((column) => (column.accessorKey ? row[column.accessorKey] : "")),
    ]);

    doc.autoTable({
      head: [headers],
      body: bodyData,
      theme: "striped",
      startY: titleY + 10,
      headStyles: {
        fillColor: [132, 23, 26],
        textColor: [255, 255, 255],
      },
    });

    doc.save("IbanList.pdf");
  };

  useEffect(() => {
    const tooltipTriggerList = Array.from(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new window.bootstrap.Tooltip(tooltipTriggerEl);
    });
  }, []);

  const handleCenterDropdownChange = (event) => {
    const selectedLibraryId = event.target.value;
    setLibraryId(selectedLibraryId);
    getBooksListByLibraryId(selectedLibraryId);
  };

  const handleUsedForChange = (e) => {
    const selectedId = e.target.value;
    const selectedOption = userForList.find(
      (item) => item.id.toString() === selectedId
    );
    setValue("bankUsedForId", selectedId, { shouldValidate: true });
    setValue("bankUsedForName", selectedOption ? selectedOption.value : "", {
      shouldValidate: true,
    });
  };

  const saveData = async (data) => {
    if (!token) {
      toast.error("Unauthorized. Please log in again.");
      return;
    }

    try {
      // Create FormData object to handle file upload
      const formData = new FormData();
      formData.append("Id", data.id ?? ""); // Use empty string if null
      formData.append("BankCode", data.bankCode || "");
      formData.append("Name", data.bankName || "");
      formData.append("IBAN", data.ibanNo || "");
      formData.append("BBAN", data.bbanNo || "");
      formData.append("createdBy", data.createdBy || "");
      formData.append("BankUsedForId", data.bankUsedForId || "");
      formData.append("BankUsedForName", data.bankUsedForName || "");
      formData.append("isActive", data.inActive ? "true" : "false"); // Convert boolean to string
      formData.append("VirtualIBAN", data.virtualIBAN || "");
      formData.append("BankUsedForId", data.usedFor || "");
      if (data.excelFile && data.excelFile[0]) {
        formData.append("File", data.excelFile[0]); // Append the file if it exists
      }

      // Make the API call to save the bank setup
      const response = await post("CommonSettings/SaveBankSetup", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data", // Required for file upload
        },
      });

      // Check the response
      if (response.isSuccess) {
        toast.success(response.message || "Bank setup saved successfully!");
        setTriggerRerender((prev) => !prev); // Trigger a re-render to refresh the data table (if applicable)
        reset({
          id: null,
          bankCode: "",
          name: "",
          iban: "",
          bban: "",
          bankUsedForId: "",
          bankUsedForName: "",
          isActive: false,
          virtualIBAN: "",
          file: null,
          createdBy: localStorage.getItem("userId"),
        });
        getBooksListByLibraryId();
      } else {
        toast.error(response.message || "Failed to save bank setup.");
      }
    } catch (error) {
      console.error("Error saving bank setup:", error);
      toast.error(
        error.response?.data?.message ||
          "An error occurred while saving the bank setup."
      );
    }
  };

  const handleChangeOfInputWithLengthCheck = (fieldName) => (e) => {
    const value = e.target.value;
    setValue(fieldName, value, { shouldValidate: true });
  };

  useEffect(() => {
    const filtered = booksList.filter((book) => {
      const searchLower = searchTerm.toLowerCase();
      return (
        book.title.toLowerCase().includes(searchLower) ||
        book.copiesAvailable.toString().includes(searchLower)
      );
    });
    setFilteredBooksList(filtered);
  }, [searchTerm, booksList]);
  const handleCustomDropdownSetting = (dropdownName) => {
    setCustomDropdownName(dropdownName);
    setIsCustomDropdownValuesModalVisible(true);
  };
  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading mb-2 fs-7">Bank Setup</h2>
      </div>
      <div className="row g-3">
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <form
                className="row g-3 new-form-style"
                onSubmit={handleSubmit(saveData)}
              >
                <div className="col-md-4">
                  <label className="form-label form-label-new">
                    Bank Code<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register("bankCode", {
                      required: "This field is required.",
                      maxLength: {
                        value: 75,
                        message: "Maximum of 75 characters allowed.",
                      },
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                    onChange={handleChangeOfInputWithLengthCheck("bankCode")}
                  />
                  {errors.bankCode && (
                    <small className="text-danger">
                      {errors.bankCode.message}
                    </small>
                  )}
                </div>
                <div className="col-md-4">
                  <label className="form-label form-label-new">
                    Bank Name<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register("bankName", {
                      required: "This field is required.",
                      maxLength: {
                        value: 75,
                        message: "Maximum of 75 characters allowed.",
                      },
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                    onChange={handleChangeOfInputWithLengthCheck("bankName")}
                  />
                  {errors.bankName && (
                    <small className="text-danger">
                      {errors.bankName.message}
                    </small>
                  )}
                </div>
                <div className="col-md-4">
                  <label className="form-label form-label-new">
                    IBAN No<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register("ibanNo", {
                      required: "This field is required.",
                      maxLength: {
                        value: 75,
                        message: "Maximum of 75 characters allowed.",
                      },
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                    onChange={handleChangeOfInputWithLengthCheck("ibanNo")}
                  />
                  {errors.ibanNo && (
                    <small className="text-danger">
                      {errors.ibanNo.message}
                    </small>
                  )}
                </div>
                <div className="col-md-4">
                  <label className="form-label form-label-new">
                    BBAN No<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register("bbanNo", {
                      required: "This field is required.",
                      maxLength: {
                        value: 75,
                        message: "Maximum of 75 characters allowed.",
                      },
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                    onChange={handleChangeOfInputWithLengthCheck("bbanNo")}
                  />
                  {errors.bbanNo && (
                    <small className="text-danger">
                      {errors.bbanNo.message}
                    </small>
                  )}
                </div>
                <div className="col-md-4">
                  <label className="form-label form-label-new">
                    Used For<span className="text-danger fs-9">*</span>
                  </label>
                  <div className="d-flex gap-2">
                    <div className="w-100">
                      <select
                        {...register("usedFor", {
                          required: "This field is required.",
                        })}
                        className="form-select"
                      >
                        <option value="">Select</option>
                        {userForList.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.value}
                          </option>
                        ))}
                      </select>
                      {errors.usedFor && (
                        <small className="text-danger">
                          {errors.usedFor.message}
                        </small>
                      )}
                    </div>
                    <div>
                      <button
                        type="button"
                        className="btn btn-outline-primary"
                        style={{
                          padding: "5.5px 10px",
                        }}
                        onClick={() =>
                          handleCustomDropdownSetting("BankUsedForDropdown")
                        }
                      >
                        <i className="fas fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <label className="form-label">
                    Inactive<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    control={control}
                    name="inActive"
                    render={({ field }) => (
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={field.value}
                        onChange={(e) => field.onChange(e.target.checked)}
                      />
                    )}
                  />
                  {errors.inActive && (
                    <small className="text-danger">
                      {errors.inActive.message}
                    </small>
                  )}
                </div>
                {usedForValue !== "Registration Voucher" &&
                  usedForValue !== "Admission Voucher" && (
                    <div className="col-md-4">
                      <label className="form-label form-label-new">
                        Upload Excel File
                        <span className="text-danger fs-9">*</span>
                      </label>
                      <input
                        type="file"
                        accept=".xls,.xlsx"
                        className="form-control"
                        {...register("excelFile", {
                          required:
                            usedForValue &&
                            usedForValue !== "78" &&
                            usedForValue !== "79"
                              ? "This field is required."
                              : false,
                        })}
                      />
                      {errors.excelFile && (
                        <small className="text-danger">
                          {errors.excelFile.message}
                        </small>
                      )}
                    </div>
                  )}
                <div className="col-12 mt-3">
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Saving..." : "Save"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <CustomDatatableGrid
                columns={columns}
                data={filteredBooksList}
                onExportExcel={exportToExcel}
                onExportPDF={exportToPDF}
              />
            </div>
          </div>
        </div>
      </div>
      {isCustomDropdownValuesModalVisible && (
        <DropdownWithCustomValuesModal
          dropdownName={customDropdownName}
          onClose={() => {
            setIsCustomDropdownValuesModalVisible(false);
            if (customDropdownName === "BankUsedForDropdown") {
              fetchCommonSettings("BankUsedForDropdown", setUserForList);
            }
          }}
        />
      )}
    </>
  );
}

export default BankSetup;
